import {default as PasswordForm} from './change-password';

export default {
    PasswordForm
};